import { IGetVillageListRequestSchema } from '../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { getSeoUrls } from '../api/get_seo_urls';
import { COMMON_VILLAGES_PATH } from '../constants';
import { IReduxThunkContext } from '../types/store';
import { generateQueryString } from './filters';

export async function getSeoUrlPath(
  context: IReduxThunkContext,
  rawPath: string,
  filters: IGetVillageListRequestSchema,
  addFiltersState: boolean = false,
) {
  let path = rawPath;
  let qs = generateQueryString(filters, false);
  if (!addFiltersState) {
    const seoUrls = await getSeoUrls(context.httpApi, context.logger, { queryStrings: [qs] }, context.subdomain);

    const seoUrl = seoUrls && seoUrls[qs];
    if (seoUrl) {
      path = seoUrl;
      qs = '';
    } else {
      path = COMMON_VILLAGES_PATH;
      qs = generateQueryString(filters, false, true);
    }
  }
  if (qs && addFiltersState) {
    qs += '&filters=opened';
  }

  return qs ? `${path}?${qs}` : path;
}
